export default __webpack_public_path__ + "static/media/kampagne_2_hundehalsband.63ce0821.png";